module.exports = __webpack_public_path__ + "50e1c455.png";